import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PaymentFailure = () => {
    const navigate = useNavigate();

    const handleFailure = async =>{
        navigate('/pricing-plans');
    }

    return (
        <div className="login-container">
            <Card className="login-card gradient-border">
                <Card.Body>
                    <div className="text-center mb-5 mt-2">
                        <img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="App-logo" alt="logo" />
                    </div>
                    <Row className="text-center">
                        <Col sm={12}>
                            <img 
                            style={{ height: "60px", width: "60px", color: 'red'}} 
                            src={`${process.env.PUBLIC_URL}/images/failure.png`} 
                            alt="green_check" 
                            className="mb-2" 
                            />
                        </Col>
                        <Col sm={12}>
                            <p style={{ fontSize: '24px', margin: '10px 0', color: "white", marginTop:"15px" }}>Payment Failed</p>
                        </Col>
                        <div>
                            <Button 
                                variant="primary" 
                                type="submit" 
                                className="mt-5 w-100 p-2 theme-btn"
                                onClick={handleFailure}
                            >
                                Retry
                            </Button>
                        </div>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default PaymentFailure;